import React from 'react'
import { Select } from 'antd'
import { SourceFilterDropdownProps, NotificationSourceFilterValues } from './types'

const { Option } = Select

const SourceFilterDropdown: React.FC<SourceFilterDropdownProps> = ({
  autoPinnedCount,
  notAutoPinnedCount,
  selectedSource,
  onSourceChange
}) => {
  return (
    <Select
      value={selectedSource}
      onChange={onSourceChange}
      style={{ width: 220 }}
      data-testid="source-filter-dropdown"
    >
      <Option value={NotificationSourceFilterValues.ALL}>Show all</Option>
      <Option value={NotificationSourceFilterValues.AUTO_PINNER}>Only auto-pinned ({autoPinnedCount})</Option>
      <Option value={NotificationSourceFilterValues.NOT_AUTO_PINNER}>Not auto-pinned ({notAutoPinnedCount})</Option>
    </Select>
  )
}

export default SourceFilterDropdown
